import Renderer from '../../../react_renderer';

const RemoteReservations = (() => {
  const bumpStatus = '[data-bump-status]';
  const bumpContainer = '[data-inline-bump]';
  const remoteBumpStatus = 'data-bump-remote-status';
  const remoteReservationForm = 'form[data-bump-remote-reservation=true]';

  function hideAlerts(panel) {
    panel.find(`[${remoteBumpStatus}]`).hide();
  }

  function panelForForm(form) {
    return form.parent();
  }

  function initJs(container) {
    initTips(container);
    Renderer.render(window, container[0]);
  }

  function reservationCreatedSuccessfully(form, html) {
    const panel = panelForForm(form);
    hideAlerts(panel);

    const container = panel.closest(bumpContainer);
    container.find('[data-bump-dropdown]').hide();
    if (container.find('.panel-content:visible').length) {
      container.find('[data-panel]').click();
    }

    container.find(bumpStatus).html(html);
    container.find(bumpStatus).show();
    initJs(container);
  }

  function reservationError(form) {
    const panel = panelForForm(form);
    hideAlerts(panel);
    panel.find(`[${remoteBumpStatus}=error]`).show();
  }


  function bindBumpSubmit() {
    $(document).on('submit', remoteReservationForm, function (e) {
      e.preventDefault();
      const $form = $(this);
      const url = $form.attr('action');
      $.post(url, $form.serialize())
        .done((data) => {
          reservationCreatedSuccessfully($form, data);
        }).fail(() => {
          reservationError($form);
        });
    });
  }

  function init() {
    bindBumpSubmit();
  }

  return {
    init,
  };
})();

$(RemoteReservations.init());

export default RemoteReservations;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump/remote_reservations.js